<ion-app>
  <ion-split-pane contentId="main-content" when="(min-width: 2000px)">
    <ion-menu contentId="main-content" side="start" class="side-nav">
      <!-- <ion-header>
        <ion-toolbar color="primary">
          <ion-title>Bag2Bag</ion-title>
          <div class="tool-head">
            <div>
              <ion-img class="logo" [src]="'/assets/images/logo/new-logo.png'"></ion-img>
            </div>
            <div>
              <ion-icon name="close-circle"></ion-icon>
            </div>
          </div>
        </ion-toolbar>
      </ion-header> -->
      <ion-content class="side-menu">
        <ion-list class="left-menu">
          <b2b-vertical-navigation></b2b-vertical-navigation>
          <!--<ng-container *ngFor="let navigation of routerUtilService.navigations">
            <ion-item
              (click)="togglePage()"
              [routerLink]="navigation?.url"
            >{{ navigation?.title }}</ion-item>
          </ng-container>

          <ion-item
            href="javascript:void(0)"
            (click)="logout();togglePage();"
          >Logout
          </ion-item>-->

        </ion-list>

      </ion-content>
    </ion-menu>


    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <b2b-ripple-loader></b2b-ripple-loader>
</ion-app>
